import { FC, useEffect, useState } from 'react';
import { CheckIcon, CloseIcon } from '@/shared/icons';
import { Textarea } from '@/shared/Textarea';
import { MessageTextComposerOwnProps } from './interfaces';
import { getNormalizedText, hasSubmittableText } from '@/shared/textSubmit';

export const MessageTextComposer: FC<MessageTextComposerOwnProps> = ({
  messageTitle,
  submitting,
  editing,
  onFocus,
  onClose,
  onSubmit,
}) => {
  const [value, setValue] = useState('');

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (!hasSubmittableText(value) || submitting) return;
    onSubmit(getNormalizedText(value));
  };

  useEffect(() => {
    setValue(messageTitle);
  }, [messageTitle]);

  return (
    <div className="relative min-h-[72px] rounded-[16px] bg-grey-light p-4 dark:bg-black">
      <div className="pr-[92px]">
        <Textarea
          className="w-full resize-none border-none bg-transparent text-md font-medium text-grey-black outline-none placeholder-grey-hover dark:text-grey-main-dark dark:placeholder-grey-hover-dark"
          placeholder="Ask something"
          value={value}
          rows={1}
          autoFocus
          onFocus={(e) => {
            const el = e.currentTarget;
            el.setSelectionRange(el.value.length, el.value.length);
            onFocus();
          }}
          onChange={e => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
      {editing && (
        <div className="absolute top-1/2 right-4 flex -translate-y-1/2 gap-2">
          <button
            onClick={() => {
              onClose();
              setValue(messageTitle);
            }}
            className="flex h-8 w-8 items-center justify-center rounded-full bg-grey-light text-black transition-colors hover:bg-peach dark:bg-grey-main dark:text-grey-light"
          >
            <CloseIcon />
          </button>
          <button
            onClick={handleSubmit}
            disabled={
              submitting
              || !hasSubmittableText(value)
              || getNormalizedText(value) === getNormalizedText(messageTitle)
            }
            className="flex h-8 w-8 items-center justify-center rounded-full bg-positive-primary text-white transition-colors hover:bg-positive-hover hover:disabled:bg-positive-primary disabled:cursor-not-allowed disabled:text-positive-subtitle"
          >
            <CheckIcon />
          </button>
        </div>
      )}
    </div>
  );
};
